import { createAction } from 'redux-actions';

import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../../../networking/utils';
import { BlockedUser } from './types';

export const setBlockedUsernamesWidgetBlockedUsers = createAction(
  `${reduxKey}.SET_BLOCKEDUSERNAMES_WIDGET_BLOCKED_USERS`,
  (blockedUsers: BlockedUser[]) => ({ blockedUsers })
);

export const {
  submit: saveBlockedUsernames,
  success: saveBlockedUsernamesSuccess,
  failure: saveBlockedUsernamesFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_BLOCKED_USERNAMES');
